
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier-code-of-conduct",
      function () {
        return require("private-next-pages/supplier-code-of-conduct.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier-code-of-conduct"])
      });
    }
  